
import { $ } from "../third-party-imports"

export function addClassInModalWindow(modalId: any)
{
    $('.servive-form-wrapperBox').removeClass('personalInfoSlides');
    $('#' + modalId).addClass('personalInfoSlides');
}
